/**
 * Transition d'ecran : fondu + translation de 12 px vers le haut, 300 ms,
 * transform/opacity uniquement. Respecte prefers-reduced-motion via les tokens
 * (--dur-screen tombe a 0 dans ce mode).
 *
 * `key` sur ce composant suffit a rejouer l'animation : chaque phase monte sa
 * propre instance.
 */
import type { ReactElement, ReactNode } from 'react';
import { useT } from '../locales/useT.js';

export function Screen({
  children,
  name,
  scroll = false,
}: {
  children: ReactNode;
  /** Sert de cle d'animation : changer de nom rejoue l'entree. */
  name: string;
  /**
   * L'ecran defile-t-il ? Quand oui, c'est CE bloc qui porte le scroll, sur
   * toute la largeur de la fenetre. Le faire porter par la colonne de contenu
   * (max-width, centree) rendait la molette inerte partout ailleurs : il
   * fallait viser le centre de l'ecran pour defiler.
   */
  scroll?: boolean;
}): ReactElement {
  return (
    <div className={scroll ? 'screen screen--scroll' : 'screen'} key={name}>
      {children}
    </div>
  );
}

export function ReconnectingBanner({ visible }: { visible: boolean }): ReactElement | null {
  const t = useT();
  if (!visible) return null;
  // Non bloquant : le jeu continue derriere, la barre se contente d'informer.
  return (
    <div className="reconnect-banner" role="status">
      <span className="reconnect-banner__dot" />
      {t('net.reconnecting')}
    </div>
  );
}
